import FormWidgetType from 'scoreboard/forms/model/form-widget-type'
const {
	FIELD, BUTTON, CHECKBOXES,
	RECORD_LIST, TEXT, DASHBOARD
} = FormWidgetType
import WidgetState from 'scoreboard/forms/model/widget-state'
const {
	CLICKABLE, TEXT_ONLY, VISIBLE,
	EDITABLE, DISABLED, HIDDEN
} = WidgetState
import { PRIMARY, SECONDARY } from 'scoreboard/forms/model/widget-appearance'
import FormActionType from 'scoreboard/forms/model/form-action-type'
const {
	SAVE_RECORD,
	NEW_RECORD,
	GO_TO_PAGE,
	CHANGE_WIDGET_STATE,
	CHANGE_WIDGET_VALIDATION,
	SET_FIELD_VALUE,
	SEND_ALERT
} = FormActionType

import FieldWidget from './field-widget'
import ButtonWidget from './button-widget'
import RecordListWidget from './record-list-widget'
import CheckboxesWidget from './checkbox-widget'
import TextWidget from './text-widget'
import FieldEditor from './field-widget-editor'
import ButtonEditor from './button-widget-editor'
import RecordListEditor from './record-list-widget-editor'
import CheckboxesEditor from './field-widget-editor'
import TextEditor from './text-widget-editor'
import SaveRecordActor from '../actions/save-record-actor'
import NewRecordActor from '../actions/new-record-actor'
import GoToPageActor from '../actions/go-to-page-actor'
import ChangeWidgetStateActor from '../actions/change-widget-state-actor'
import ChangeWidgetValidationActor from '../actions/change-widget-validation-actor'
import SetFieldValueActor from '../actions/set-field-value-actor'
import SendAlertActor from '../actions/send-alert-actor'
import DashboardWidget from './dashboard-widget'
import DashboardWidgetEditor from './dashboard-widget-editor'

const widgetMetadata = {
	views: {
		[FIELD]: FieldWidget,
		[BUTTON]: ButtonWidget,
		[RECORD_LIST]: RecordListWidget,
		[CHECKBOXES]: CheckboxesWidget,
		[TEXT]: TextWidget,
		[DASHBOARD]: DashboardWidget
	},
	editors: {
		[FIELD]: FieldEditor,
		[BUTTON]: ButtonEditor,
		[RECORD_LIST]: RecordListEditor,
		[CHECKBOXES]: CheckboxesEditor,
		[TEXT]: TextEditor,
		[DASHBOARD]: DashboardWidgetEditor
	},
	actors: {
		[SAVE_RECORD]: SaveRecordActor,
		[NEW_RECORD]: NewRecordActor,
		[GO_TO_PAGE]: GoToPageActor,
		[CHANGE_WIDGET_STATE]: ChangeWidgetStateActor,
		[CHANGE_WIDGET_VALIDATION]: ChangeWidgetValidationActor,
		[SET_FIELD_VALUE]: SetFieldValueActor,
		[SEND_ALERT]: SendAlertActor
	},
	states: {
		[FIELD]: [EDITABLE, TEXT_ONLY, DISABLED, HIDDEN],
		[CHECKBOXES]: [EDITABLE, TEXT_ONLY, DISABLED, HIDDEN],
		[BUTTON]: [CLICKABLE, DISABLED, HIDDEN],
		[RECORD_LIST]: [VISIBLE, HIDDEN],
		[TEXT]: [VISIBLE, HIDDEN],
		[DASHBOARD]: [VISIBLE, HIDDEN]
	},
	appearances: {
		[BUTTON]: [PRIMARY, SECONDARY]
	}

}

export default widgetMetadata

widgetMetadata.__filename__ = 'forms/widgets/widget-metadata.js'
